<template>
    <div id="app">
        <v-app id="inspire">
            <v-navigation-drawer
                v-model="drawer"
                :clipped="$vuetify.breakpoint.lgAndUp"
                app
                v-if="isLoggedIn"
            >
                <v-list dense>
                    <v-list-item link :to="{ name: 'Home' }" exact>
                        <v-list-item-action>
                            <v-icon>mdi-home</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>หน้าแรก</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item
                        link
                        :to="{ name: 'LottoWaitingResults' }"
                        v-if="isAdmin"
                    >
                        <v-list-item-action>
                            <v-icon>mdi-chart-donut</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>หวยรอการออกผล</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item link :to="{ name: 'LottoResults' }">
                        <v-list-item-action>
                            <v-icon>mdi-chart-timeline</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>ผลหวย</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item link :to="{ name: 'Holidays' }" v-if="isAdmin">
                        <v-list-item-action>
                            <v-icon>mdi-calendar-remove-outline</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>วันหยุดหวย</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item link @click="show_change_password = true">
                        <v-list-item-action>
                            <v-icon>mdi-lock</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title
                                >เปลี่ยนรหัสผ่าน</v-list-item-title
                            >
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item link @click="logout">
                        <v-list-item-action>
                            <v-icon>mdi-logout</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>ออกจากระบบ</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>
            </v-navigation-drawer>

            <v-app-bar
                :clipped-left="$vuetify.breakpoint.lgAndUp"
                app
                color="blue darken-3"
                dark
                v-if="isLoggedIn"
            >
                <v-app-bar-nav-icon
                    @click.stop="drawer = !drawer"
                ></v-app-bar-nav-icon>
                <v-toolbar-title>LOTTO FAKER</v-toolbar-title>
                <v-spacer></v-spacer>
                <div class="h1 white-text d-none d-md-flex">
                    <v-icon class="mr-2">mdi-clock</v-icon>
                    {{ time }}
                </div>
                <v-spacer></v-spacer>
                <div class="mx-2 h1 white-text d-none d-sm-flex">
                    <v-icon>mdi-account</v-icon>
                    {{ user.username }}
                </div>
                <v-btn color="dark" class="d-none d-sm-block" @click="logout"
                    >Logout</v-btn
                >
            </v-app-bar>

            <v-main>
                <router-view />
            </v-main>
            <v-footer color="blue darken-3" app v-if="isLoggedIn">
                <span class="white--text mx-auto"
                    >&copy; {{ new Date().getFullYear() }} LOTTO FAKER</span
                >
            </v-footer>
            <change-password-dialog v-model="show_change_password" />
        </v-app>
        <notifications
            animation-type="velocity"
            classes="notification-style"
            position="top right"
        />
    </div>
</template>
<script>
import { mapGetters } from "vuex";
import moment from "moment-timezone";
import ChangePasswordDialog from "./components/ChangePasswordDialog";

const TIME_FORMAT = "Do MMM YYYY เวลา HH:mm:ss";

export default {
    components: { ChangePasswordDialog },
    data: () => {
        return {
            drawer: null,
            show_change_password: false,
            time: moment().format(TIME_FORMAT),
        };
    },
    computed: {
        ...mapGetters("auth", ["isLoggedIn", "user", "isAdmin"]),
    },
    created() {
        this.startClock();
    },
    methods: {
        startClock() {
            setInterval(() => {
                this.time = moment().format(TIME_FORMAT);
            }, 1000);
        },
        logout() {
            this.$store.dispatch("auth/logout");
            this.$router.push({
                name: "Login",
            });
        },
    },
};
</script>
<style lang="scss">
.notification-style {
    padding: 10px;
    margin: 5px 5px 5px;

    font-size: 14px;

    color: #ffffff;
    background: #44a4fc;
    border-left: 5px solid #187fe7;

    &.warn {
        background: #ffb648;
        border-left-color: #f48a06;
    }

    &.error {
        background: #e54d42;
        border-left-color: #b82e24;
    }

    &.success {
        background: #68cd86;
        border-left-color: #42a85f;
    }
}
</style>
